import { BaseIcon, BaseIconProps } from '../BaseIcon';
type SuccessMiniIconProps = Omit<BaseIconProps, 'children'>;
export const SuccessMiniIcon = (props: SuccessMiniIconProps) => (
  <BaseIcon width={12} height={12} viewBox="0 0 12 12" {...props}>
    <g clipPath="url(#MiniSuccess_svg__a)">
      <circle cx={6} cy={6} r={6} fill="#00C389" />
      <path
        fill="#fff"
        d="M9.513 3.364a.525.525 0 0 0-.724.068L4.926 7.983l-1.53-1.65a.526.526 0 0 0-.726-.038.49.49 0 0 0-.038.706L4.56 9.085a.522.522 0 0 0 .78-.017l4.242-5a.49.49 0 0 0-.069-.704"
      />
    </g>
    <defs>
      <clipPath id="MiniSuccess_svg__a">
        <path fill="#fff" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </BaseIcon>
);
export default SuccessMiniIcon;
SuccessMiniIcon.displayName = 'SuccessMiniIcon';
